import { useEffect } from 'react';
import { useContext, createContext } from 'react';

const PreventScrollContext = createContext({ hookCount: 0 });

/**
 * Apply class on document body if necessary.
 */
function syncClasses(hookCount: number): void {
  if (typeof window === 'undefined') {
    return;
  }

  if (hookCount > 0) {
    document.documentElement.classList.add('no-scroll');
  } else {
    document.documentElement.classList.remove('no-scroll');
  }
}

/**
 * Applies a special class which will prevent scrolling of the viewport.
 *
 * @param prevent Whether to prevent scrolling or not.
 */
export function usePreventScroll(prevent = true) {
  const context = useContext(PreventScrollContext);

  //
  // Since the hook may be used multiple times at a time. We count the number
  // of active hooks at a time. Then if the count is zero, we know, nobody is
  // blocking the scroll.
  //
  useEffect(() => {
    const delta = prevent ? 1 : -1;
    context.hookCount += delta;
    syncClasses(context.hookCount);

    return () => {
      context.hookCount -= delta;
      syncClasses(context.hookCount);
    };
  }, [prevent, context]);
}
